import { Box, Typography, styled } from '@mui/material';

import { flexMixin } from 'utils/flexMixin';

import { regularTextColor, titleTextColor } from 'assets/styles/_palette';

export const Owner = styled(Box)({
	...flexMixin({ justify: 'flex-start', gap: 8 }),
});

export const OwnerInfo = styled(Box)({
	...flexMixin({ align: 'flex-start', direction: 'column' }),

	'& h4, & p': {
		fontSize: '14px',
		fontWeight: '400',
		lineHeight: '143%',
		letterSpacing: '0.15px',
		color: titleTextColor,
	},
	'& p': {
		color: '#9FA6B3',
	},
});

export const ModalUser = styled(Box)({
	...flexMixin({ justify: 'flex-start' }),
	width: '100%',
});

export const AccessData = styled(Typography)({
	width: '22.5%',
	textAlign: 'center',
	color: regularTextColor,
});
